module.exports = __webpack_public_path__ + "static/img/so2_3.35813c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so2_3.jpg
// module id = ZJ8U
// module chunks = 11